import {client} from 'utils/api-client';
import { AxiosRequestConfig } from 'axios'
import {toast} from '@mayo/mayo-ui-gakki';
type ClientOption = {
  data?: any;
} & AxiosRequestConfig;

export type APIClient = {
  get: <T>(endpoint: string, config?: ClientOption) => Promise<T>;
  post: <T>(endpoint: string, config?: ClientOption) => Promise<T>;
  put: <T>(endpoint: string, config?: ClientOption) => Promise<T>;
  delete: <T>(endpoint: string, config?: ClientOption) => Promise<T>;
};

const handler = async (endpoint: string, config: ClientOption = {}) => {
  try {
    const response = await client(endpoint, {...config,});
    return Promise.resolve(response);
  } catch (error: any) {
    switch (error?.code) {
      case 500:
        toast.error('系統異常');
        break;
      default:
        toast.error(error.message);
        break;
    }
    return Promise.reject(error);
  }
}
export const api = {
    get: (endpoint: string, config: ClientOption = {}) =>
        handler(endpoint, {method: 'get', ...config}),
    post: (endpoint: string, config: ClientOption = {}) =>
        handler(endpoint, {method: 'post', ...config}),
    put: (endpoint: string, config: ClientOption = {}) =>
        handler(endpoint, {method: 'put', ...config}),
    delete: (endpoint: string, config: ClientOption = {}) =>
        handler(endpoint, {method: 'delete', ...config}),
};